<template>
    <div class="flex flex-row pt-6">
        <p
            @click="navigate('create')"
            :class="{'bg-gray-700 shadow-none': action === 'create'}"
            class="px-2 py-1 mb-2 mr-2 text-white bg-gray-500 rounded-md shadow-lg cursor-pointer hover:shadow-none text-md create-item"
        >
            Add Items
        </p>
        <p
            @click="navigate('edit')"
            :class="{'bg-gray-700 shadow-none': action === 'edit'}"
            class="px-2 py-1 mx-2 mb-2 text-white bg-gray-500 rounded-md shadow-lg cursor-pointer hover:shadow-none text-md edit-item"
        >
            Edit Items
        </p>
        <p
            @click="navigate('delete')"
            :class="{'bg-gray-700 shadow-none': action === 'delete'}"
            class="px-2 py-1 mb-2 ml-2 text-white bg-gray-500 rounded-md shadow-lg cursor-pointer hover:shadow-none text-md delete-item"
        >
            Delete Items
        </p>
    </div>
</template>

<script>
export default {
  name: 'subNavbar',
  props: {
    action: {
      type: String,
      required: true,
      validator: (action) => ['create', 'edit', 'delete'].includes(action),
    },
  },
  methods: {
    navigate(newAction) {
      this.$emit('navigate', newAction);
    },
    navbar(newAction) {
      const isActive = this.action == newAction;
      return {
        active: isActive,
        underline: isActive,
        'font-medium': isActive,
      };
    },
  },
};
</script>
